module.exports = __webpack_public_path__ + "324384db.mp4";


//////////////////
// WEBPACK FOOTER
// ./public/images/video.mp4
// module id = 1152
// module chunks = 0 1 2